import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HeaderService } from '../../core/services/header.service';
import { AuthService } from '../../core/security/auth.service';
import { BehaviorSubject, merge } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MessageLogsDatasource } from './message-logs.datasource';
import { AdvancedMessagingService as AdvancedMessagingApiService } from '../../api/services/advanced-messaging.service';
import { MessageLogsRequest } from '../../api/models/message-logs-request';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-message-logs-grid',
    templateUrl: './message-logs-grid.component.html',
    styleUrls: ['./message-logs-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
        DateTimePipe,
    ],
})
export class MessageLogsGridComponent implements OnDestroy, OnInit {
  displayedColumns: string[] = ['eventType', 'direction', 'createdOn', 'tnFrom', 'tnTo', 'deliveryDescription'];
  @Input() filterChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  additionalFilter: any = {};
  smsType: string = '';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MessageLogsDatasource;

  isSendByVisible = new BehaviorSubject<boolean>(false);

  constructor(
    public dialog: MatDialog,
    public headerService: HeaderService,
    public authService: AuthService,
    private advancedMessagingApiService: AdvancedMessagingApiService,
  ) {}

  ngOnInit() {
    this.dataSource = new MessageLogsDatasource(this.advancedMessagingApiService);

    this.filterChangeEvent?.subscribe(filter => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
      this.smsType = filter.type;

      setTimeout(() => {
        if (this.smsType !== 'incoming') {
          this.displayedColumns.push('sendBy');
          this.isSendByVisible.next(true);
        }
      });
    });

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(tap(() => this.loadData()))
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): MessageLogsRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [
        { field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined },
      ],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {}
}
